import React, { useState } from "react";
import Header from "../components/header";
import Footer from "../components/footer";
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import PinterestIcon from '@mui/icons-material/Pinterest';
import ProductSingle from "../components/product";
import FavoriteIcon from '@mui/icons-material/Favorite';
import listProduct from '../components/product.json'
const SingleProduct = (props) =>{
    const [description,setDescription] = useState(1)
    const [like,setLike] = useState(false)
    const [imgset,setImgset] = useState(props.location.state.product.imgs[0])
    document.body.style.backgroundColor = "white"
    return (
        <div>
            <Header />
               <section id="section_shop">
                   <div className="row col-12">
                       <div className="col-sm-7">
                            <div className="row col-12">
                                <div className="col-2" id="saknf">
                                <ul id="single_product_ul">
                                        {
                                            props.location.state.product.imgs.map((v,k)=>{
                                                return  <li key={k}
                                                onClick={(()=>{
                                                    return setImgset(v)  
                                                })}
                                                >
                                                <img id="single_product_ul_img" alt="" src={v} />
                                            </li>
                                            })
                                        }
                                    </ul>
                                </div>
                                <div className="col-10">
                                <img id="single_product_ul_img_right" alt="" src={imgset} />
                                </div>
                            </div>
                       </div>
                       <div className="col">
                            <div id="right_side_single_product">
                            <p id="right_side_single_product_0">Home / Shop / <u>{props.location.state.product.name}</u></p>
                                <p id="right_side_single_product_1">{props.location.state.product.name}</p>
                                <p id="right_side_single_product_2">20 reviews</p>
                                <p id="right_side_single_product_3">Loose-fitting long sleeve sweatshirt with a round neckline and ribbed trims.
                                    Includes white speckled ceramic vase and metal wire frame. Designed by 
                                    Sung Wook Park.</p>
                                <ul id="right_side_single_product_ul">
                                    <li>- 100% polyester</li>
                                    <li>- 98% polyester,</li>
                                    <li>- 2% elastane</li>
                                </ul>
                                <hr id="right_side_single_product_line" />
                                <p id="right_side_single_product_4">{props.location.state.product.price}</p>
                                <hr id="right_side_single_product_line" />
                                <ul id="right_side_single_product_ul_2">
                                    <li>
                                        <button id="right_side_single_product_ul_2_button">Add To Cart</button>
                                    </li>
                                    <li 
                                    onClick={(()=>{
                                        if(like === true){
                                            setLike(false)
                                        }else{
                                            setLike(true) 
                                        }
                                        
                                    })}
                                    >
                                        {
                                            like === false ? 
                                            <FavoriteBorderIcon id="heart_icon_p_s" />:
                                            <FavoriteIcon id="heart_icon_p_s" style={{color:"red"}} />
                                        }
                                       
                                    </li>
                                </ul>
                                <ul id="right_side_single_product_ul_3">
                                    <li>Availablity : <u>In Stock </u></li>
                                    <li>SKU : 14235</li>
                                    <li>Share on:</li>
                                </ul>
                                <ul id="right_side_single_product_ul_2">
                                    <li>
                                    <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
                                        <FacebookIcon />
                                    </a>
                                    </li>
                                    <li>
                                    <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
                                        <InstagramIcon />
                                    </a>
                                    </li>
                                    <li>
                                    <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
                                        <TwitterIcon />
                                    </a>
                                    </li>
                                    <li>
                                    <a href="https://pinterest.com" target="_blank" rel="noopener noreferrer">
                                        <PinterestIcon />
                                    </a>
                                    </li>
                                </ul>
                            </div>
                       </div>
                   </div>
                   <hr id="right_side_single_product_line" style={{marginTop:"50px"}}/>
                   <ul id="s_p_d_ul">
                       {
                           description === 1 ?
                           <li id="act">Descripsion</li>:
                           <li 
                           onClick={(()=>{
                            setDescription(1)
                           })}
                           >Descripsion</li>
                       }
                       {
                           description === 2 ?
                           <li id="act">Review (20)</li>:
                           <li 
                           onClick={(()=>{
                            setDescription(2)
                           })}
                           >Review (20)</li>
                       }
                        {
                           description === 3 ?
                           <li id="act">Additional information</li>:
                           <li 
                           onClick={(()=>{
                            setDescription(3)
                           })}
                           >Additional information</li>
                       }
                   </ul>
                   <hr id="right_side_single_product_line"/>
                   {
                       description === 1 ? 
                       <p id="description_s_p">
                           {props.location.state.product.description}
                        </p>: <></>
                   }
                   {
                       description === 2 ? 
                       <p id="description_s_p">
                           Review (20)
                        </p>: <></>
                   }
                   {
                       description === 3 ? 
                       <p id="description_s_p">
                           Additional information
                        </p>: <></>
                   }
                    
                    <hr style={{marginTop:"40px"}} />
                    <p id="similar_products">Similar Products</p>
                    <div id="grid_4_cart">
                        {
                           listProduct.map((v,k)=>{
                                return <ProductSingle key={k} data={v}/>
                            })
                        }
                    </div>
               </section>
            <Footer />
        </div>  
    )
}
export default SingleProduct;
